import { request } from "../../apis";

export const apiGetOrderList = (params: any): any =>
  request("get", `/api/user/payment/order/list`, params, true);

export const apiGetOrderDetail = (params: any): any =>
  request("get", `/api/user/order/detail/${params.order_number}`, params, true);

export const apiGetOrderFeedbackNew = (params: any): any =>
  request("get", `/api/order/feedback/new`, params, false);

export const apiPostOrderCancel = (params: any): any =>
  request("post", `/api/order/cancel`, params, true);

export const apiPostOrderFeedbackCreate = (params: any): any =>
  request("post", `/api/order/feedback/create`, params, false);

export const apiPostOrderRefund = (params: any): any =>
  request("post", `/api/order/refund`, params, true);

export const apiGetRefuncPolicy = () =>
  request("get", `/api/company/policy`, null, true);

export const apiGetUserOrderDetail = (params: any) =>
  request("get", `/api/user/payment/order/detail`, params, true);

export const apiGetRefundData = (params: any) =>
  request("get", `/api/user/payment/refund/amount`, params, true);
